import { Button, Theme, useDeviceType } from '@cian/ui-kit';
import * as style from './FindToday.css';
import { clsx } from 'clsx';
import { NBSP } from 'shared/constants/symbols';

interface IFindTodayProps {
  onOpenModal: VoidFunction;
}

export const FindToday: React.FC<IFindTodayProps> = ({ onOpenModal }) => {
  const device = useDeviceType();

  return (
    <div
      className={clsx(
        style['container'],
        device !== 'desktop' && style['container-tablet'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['text-container']}>
        <div className={style['textblock']}>
          <div className={style['title']}>Давайте найдём жильца уже{NBSP}сегодня</div>
          <div className={style['subtitle']}>Мы перезвоним и{NBSP}ответим на все вопросы</div>
        </div>
        <div className={style['image']} />
      </div>
      <div className={style['btn']}>
        <Theme theme="onOverlay">
          <Button fullWidth size="L" theme="fill_secondary" onClick={onOpenModal}>
            Оставить заявку
          </Button>
        </Theme>
      </div>
    </div>
  );
};
